export default {

	methods: {  

		debounce: _.debounce((value, vm) => (vm.atualizarRoteiro()), 4000),

		clickAtualizarRoteiro(){
			this.debounce(null, this)
		},

		atualizarRoteiro() {
			var aero = _.find(this.aeronaves, (aeronave) => {
				return aeronave.id == this.form.aeronave.id_aeronave
			})
			if (aero) {
				this.form.aeronave.roteiro = []
				this.form.aeronave.distanciaTotal = 0
				this.form.aeronave.combustivelTotal = 0
				this.form.aeronave.tempoTotal = 0
				this.form.aeronave.trecho.map((item, i) => {
					if(item.id_estado_destino != '' && item.id_estado_destino != null){
						item = this.atualizaPousoPrevisto(item, aero)
						var roteiro = this.criaRoteiro(item, i, aero)
						this.form.aeronave.roteiro.push(roteiro)
					}
				})
			}
		},

		atualizaPousoPrevisto(trecho, aero) {
			trecho.distancia = this.calculoDistancia(trecho)
			if(Number(this.disabledDatahora)){
				switch (this.flagComponente) {
				case 'basico':
					trecho = this.calculaPousoPrevistoBasico(trecho, aero)	
					break
				case 'avancado':
					trecho = this.calculaPousoPrevistoAvancado(trecho, aero)
					break
				}
			} else {
				trecho = this.calculaPousoPrevistoAvancado(trecho, aero)
			}

			return trecho
		},

		calculoDistancia(trecho) {
			const {
				designativo_partida,
				designativo_destino,
				lat_partida,
				lng_partida,
				lat_destino,
				lng_destino
			} = trecho
			var distancia = null

			if (
				designativo_partida &&
				designativo_destino &&
				designativo_partida.sigla == designativo_destino.sigla
			) {
				distancia = 'N/A'
			} else {
				if ((lat_partida, lng_partida, lat_destino, lng_destino)) {
					const lat1 = this._convertDD(lat_partida, 'lat')
					const lon1 = this._convertDD(lng_partida, 'lng')
					const lat2 = this._convertDD(lat_destino, 'lat')
					const lon2 = this._convertDD(lng_destino, 'lng')
					distancia = parseFloat(
						this._calculaDistancia(lat2, lon2, lat1, lon1)
					).toFixed(1)
				}
			}

			return distancia
		},

		calculaPousoPrevistoBasico(trecho, aero){
			if (
				trecho.designativo_partida.sigla != trecho.designativo_destino.sigla
			) {
				trecho = this.geratempoPousoPrevisto(trecho.distancia, aero, trecho)
			} else {
				if (trecho.pouso_previsto != null && trecho.pouso_previsto != '') {
					const dataDecolagem = new Date(
						this._convertDataBrForUS(
							trecho.decolagem_partida + ' ' + trecho.decolagem_partida_hora
						)
					)
					const dataPouso = new Date(
						this._convertDataBrForUS(
							trecho.pouso_previsto + ' ' + trecho.pouso_previsto_hora
						)
					)
					const diferencaEmMilissegundos = dataPouso - dataDecolagem
					const tempoDecimalMilissegundo =
									diferencaEmMilissegundos / (1000 * 60 * 60)
					trecho.tempo_voo = tempoDecimalMilissegundo.toFixed(2)
					trecho.tempo = tempoDecimalMilissegundo.toFixed(2)
					trecho.tempo_voo_utc = this.calculaTempoVooUtc(trecho)
				} else {
					trecho = this.geratempoPousoPrevisto(
						trecho.distancia,
						aero,
						trecho
					)
				}
			}
			return trecho
		},

		geratempoPousoPrevisto(distancia, aeronave, trecho) {
			let tempo = null
			if (distancia && aeronave.velocidade > 0) {
				tempo = Number(distancia) / Number(aeronave.velocidade)
				const minutosDoTempoDecimal = Math.floor(tempo * 60)

				const formatoDataHora = 'DD/MM/YYYY HH:mm'
				const dataMoment = moment(
					trecho.decolagem_partida + ' ' + trecho.decolagem_partida_hora,
					formatoDataHora
				)

				dataMoment.add(minutosDoTempoDecimal, 'minutes')
				const novaDataHoraFormatada = dataMoment.format(formatoDataHora)

				const horarioPouso = novaDataHoraFormatada.split(' ')
				trecho.pouso_previsto = horarioPouso[0]
				trecho.pouso_previsto_hora = horarioPouso[1]

				trecho.tempo_voo = minutosDoTempoDecimal / 60
				trecho.tempo = this._calculaTempo(tempo)
			}
			return trecho
		},

		calculaPousoPrevistoAvancado(trecho, aero){
			if (
				trecho.decolagem_partida != null &&
							trecho.decolagem_partida != '' &&
							trecho.decolagem_partida_hora != null &&
							trecho.decolagem_partida_hora != ''
			) {
				if (trecho.pouso_previsto != null && trecho.pouso_previsto != '') {
					const dataDecolagem = new Date(
						this._convertDataBrForUS(
							trecho.decolagem_partida + ' ' + trecho.decolagem_partida_hora
						)
					)
					const dataPouso = new Date(
						this._convertDataBrForUS(
							trecho.pouso_previsto + ' ' + trecho.pouso_previsto_hora
						)
					)
					const diferencaEmMilissegundos = dataPouso - dataDecolagem
					const tempoDecimalMilissegundo =
									diferencaEmMilissegundos / (1000 * 60 * 60)
					trecho.tempo_voo = tempoDecimalMilissegundo.toFixed(2)
					trecho.tempo = tempoDecimalMilissegundo.toFixed(2)
					trecho.tempo_voo_utc = this.calculaTempoVooUtc(trecho)
				} else {
					trecho = this.geratempoPousoPrevisto(
						trecho.distancia,
						aero,
						trecho
					)
				}
			} 
			return trecho
		},
		calculaTempoVooUtc(trecho){
			const dataDecolagemUtc = new Date(this._convertDataBrForUS(trecho.decolagem_utc_partida))
			const dataPousoUtc = new Date(this._convertDataBrForUS(trecho.pouso_previsto_utc))
			const diferencaEmMilisegundos = dataPousoUtc - dataDecolagemUtc
			const tempoDecimalMilissegundo = diferencaEmMilisegundos / (1000 * 60 * 60)
			let tempoVooUtc = tempoDecimalMilissegundo.toFixed(2)
			return tempoVooUtc
		},
		criaRoteiro(trecho, indexTrecho, aero) {
			var self = this

			var item = {}

			item = {
				//partida
				estado_partida: trecho.nome_estado_partida,
				cidade_partida: trecho.nome_cidade_partida,
				img_partida: null,
				por_partida: null,
				nascer_partida: null,
				clima_partida: null,
				temperatura_partida: null,
				vendo_partida: null,
				_tempo_partida: null,
				designativo_partida: trecho.designativo_partida.sigla,
				descricao_partida: trecho.descricao_partida,
				decolagem_data: trecho.decolagem_partida,
				decolagem_hora: trecho.decolagem_partida_hora,

				proa: 0,
				distancia: 0,
				autonomia: 0,

				// destino
				estado_destino: trecho.nome_estado_destino,
				cidade_destino: trecho.nome_cidade_destino,
				img_destino: null,
				por_destino: null,
				nascer_destino: null,
				clima_destino: null,
				temperatura_destino: null,
				_tempo_destino: null,
				designativo_destino: trecho.designativo_destino,
				descricao_destino: trecho.descricao_destino,
				pouso: trecho.pouso_previsto_hora,
				tempo: 0.0
			}

			if (indexTrecho == 0 && aero.consumo > 0) {
				item.autonomia = this.decimalToTime(aero.tanque / aero.consumo)
			}

			if (item.cidade_partida != '' && item.estado_partida != '') {
				self._getPrevisaoTempo(
					function (retorno) {
						if (retorno != false) {
							item._tempo_partida = retorno
							item.img_partida = retorno.thumb
							item.por_partida = retorno.porDoSol
							item.nascer_partida = retorno.nascerDoSol
							item.clima_partida = retorno.clima
							item.temperatura_partida = retorno.temperatura
							item.vento_partida = retorno.vento
						}
						self.$forceUpdate()
					},
					item.cidade_partida,
					item.estado_partida,
					0
				)
			}

			if (item.cidade_destino != '' && item.estado_destino != '') {
				self._getPrevisaoTempo(
					function (retorno) {
						if (retorno != false) {
							item._tempo_destino = retorno
							item.img_destino = retorno.thumb
							item.por_destino = retorno.porDoSol
							item.nascer_destino = retorno.nascerDoSol
							item.clima_destino = retorno.clima
							item.temperatura_destino = retorno.temperatura
							item.vento_destino = retorno.vento
						}
						self.$forceUpdate()
					},
					item.cidade_destino,
					item.estado_destino,
					0
				)
			}

			item.distancia = trecho.distancia

			var lat1 = this._convertDD(trecho.lat_partida, 'lat')
			var lon1 = this._convertDD(trecho.lng_partida, 'lng')
			var lat2 = this._convertDD(trecho.lat_destino, 'lat')
			var lon2 = this._convertDD(trecho.lng_destino, 'lng')

			item.proa = 'N/A'

			if (
				item.designativo_partida?.sigla &&
				item.designativo_partida.sigla == item.designativo_destino.sigla
			) {
				item.proa = 'N/A'
			} else {
				this._calculaProa(
					function (proa) {
						item.proa = Math.round(proa) + '°'
						self.$forceUpdate()
					},
					lat2,
					lon2,
					lat1,
					lon1
				)
			}

			if (item.distancia == 'N/A') {
				this.form.aeronave.distanciaTotal = 'N/A'
			} else {
				this.form.aeronave.distanciaTotal = Number(
					Number(item.distancia) + Number(this.form.aeronave.distanciaTotal)
				).toFixed(1)
			}

			if (aero.velocidade == null) {
				item.tempo = 'N/A'
				item.pouso = 'N/A'
				item.combustivel = 'N/A'
				this.form.aeronave.combustivelTotal = 'N/A'
			} else {
				if (trecho.tempo_voo_utc && trecho.tempo_voo_utc !== 'NaN') {
					item.tempo = trecho.tempo_voo_utc
					item.combustivel = Number(
						(aero.consumo * trecho.tempo_voo_utc).toFixed(2)
					)

					this.form.aeronave.tempoTotal = Number(
						Number(trecho.tempo_voo_utc) + Number(this.form.aeronave.tempoTotal)
					).toFixed(2)
					this.form.aeronave.combustivelTotal += Number(item.combustivel)
				} else if (trecho.tempo_voo && trecho.tempo_voo !== 'NaN') {
					item.tempo = trecho.tempo_voo
					item.combustivel = Number(
						(aero.consumo * trecho.tempo_voo).toFixed(2)
					)

					this.form.aeronave.tempoTotal = Number(
						Number(trecho.tempo_voo) + Number(this.form.aeronave.tempoTotal)
					).toFixed(2)
					this.form.aeronave.combustivelTotal += Number(item.combustivel)
				}

				if (indexTrecho > 0 && aero.consumo > 0) {
					item.autonomia = this.decimalToTime(
						(aero.tanque -
							this.form.aeronave.roteiro[indexTrecho - 1].combustivel) /
							aero.consumo
					)
				}
			}

			item.decolagem = this._dateTimeToDateSQL(
				trecho.decolagem_partida + ' ' + trecho.decolagem_partida_hora,
				'DD/MM/YYYY HH:MM'
			)

			if (item.cidade_partida && item.estado_partida) {
				this.geraMapa(this.form.aeronave)
			}

			return item
		},

		decimalToTime(decimal) {
			if (!decimal) {
				return '00:00'
			}
			const [horas, minutos] = parseFloat(decimal).toFixed(2).split('.')
			return `${horas.padStart(2, 0)}:${(60 * (minutos / 100))
				.toFixed(0)
				.padStart(2, 0)}`
		},

		clickAtualizaMapa() {
			this.geraMapa(this.form.aeronave)
		},

		geraMapa(aeronave, zoom) {
			var polyTrilha = []

			// exluir e inicia um novo mapa
			this.initMap(
				Number($cliente.getVersao('lat_inicio')),
				Number($cliente.getVersao('long_inicio')),
				11,
				0
			)

			var bounds = new google.maps.LatLngBounds()
			var len = aeronave.trecho.length

			for (var j in aeronave.trecho) {
				var latPartida = Number(
					this._convertDD(aeronave.trecho[j].lat_partida, 'lat')
				)
				var lngPartida = Number(
					this._convertDD(aeronave.trecho[j].lng_partida, 'lng')
				)
				var latDestino = Number(
					this._convertDD(aeronave.trecho[j].lat_destino, 'lat')
				)
				var lgnDestino = Number(
					this._convertDD(aeronave.trecho[j].lng_destino, 'lng')
				)

				// PARTIDA
				var icon =
					'https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_blue' +
					(Number(j) + 1) +
					'.png'

				polyTrilha.push({lat: Number(latPartida), lng: Number(lngPartida)})
				var polyLen = polyTrilha.length - 1
				bounds.extend(polyTrilha[polyLen])

				new google.maps.Marker({
					position: polyTrilha[polyLen],
					icon,
					map: this.maps[0]
				})

				polyTrilha.push({lat: Number(latDestino), lng: Number(lgnDestino)})
				var polyLen = polyTrilha.length - 1
				bounds.extend(polyTrilha[polyLen])
			}

			// polyline com o movimento
			var polylineLinhaConfig = new google.maps.Polyline({
				strokeColor: $cliente.getVersao('cor_polilyne'),
				path: polyTrilha,
				strokeOpacity: 1,
				icons: [
					{
						scale: 0.8,
						icon: {path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW},
						offset: '1',
						repeat: '90px'
					}
				]
			})

			polylineLinhaConfig.setMap(this.maps[0])
			this.maps[0].fitBounds(bounds)
		},

		// inicia o mapa
		initMap(lat, lng, zoom, index) {
			this.map = null

			let latLong = new google.maps.LatLng(lat, lng)

			let mapOp = {
				center: latLong,
				zoom: zoom,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				mapTypeControl: false,
				fullscreenControl: false,
				mapTypeControlOptions: {
					position: google.maps.ControlPosition.TOP_RIGHT
				},
				zoomControl: false,
				zoomControlOptions: {
					position: google.maps.ControlPosition.TOP_RIGHT
				},
				navigationControl: true,
				scrollwheel: true,
				streetViewControl: false
			}

			if(document.getElementById('map0')){
				this.maps[index] = new google.maps.Map(
					document.getElementById('map0'),
					mapOp
				)
				this._adicionaBotoes(this.maps[index])
			}
		},

		exibeRoteiro(itemRot) {
			if (
				itemRot.estado_partida != itemRot.estado_destino ||
				itemRot.cidade_partida != itemRot.cidade_destino ||
				itemRot.designativo_partida != itemRot.designativo_destino
			) {
				return true
			}
			return false
		},

	}
}
